// Lightweight loader for Leaflet.markercluster from CDN.
(function () {
  if (window.L && window.L.MarkerClusterGroup) {
    return;
  }
  function loadWhenReady() {
    if (!window.L || !window.L.map) {
      setTimeout(loadWhenReady, 50);
      return;
    }
    if (document.querySelector("script[src='https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js']")) {
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js';
    script.defer = true;
    script.crossOrigin = '';
    document.head.appendChild(script);
  }
  loadWhenReady();
})();
